import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    end: Number,
    duration: { type: Number, default: 800 }
  }

  connect() {
    this.startValue = 0
    this.frame = null
    this.observe()
  }

  disconnect() {
    if (this.frame) cancelAnimationFrame(this.frame)
  }

  observe() {
    if (!("IntersectionObserver" in window)) {
      this.animate()
      return
    }

    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.animate()
          this.observer.disconnect()
        }
      })
    }, { threshold: 0.3 })

    this.observer.observe(this.element)
  }

  animate() {
    const start = performance.now()
    const finish = start + this.durationValue
    const endValue = Number.isFinite(this.endValue) ? this.endValue : parseFloat(this.element.textContent) || 0

    const step = timestamp => {
      const progress = Math.min((timestamp - start) / this.durationValue, 1)
      const value = Math.round(this.startValue + (endValue - this.startValue) * progress)
      this.element.textContent = value.toLocaleString()
      if (timestamp < finish) this.frame = requestAnimationFrame(step)
    }

    this.frame = requestAnimationFrame(step)
  }
}
